 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import WRAP0000 from '@/components/wrap0000'
 import EBB from '@/components/ebb'
 import ALST from '@/components/alst'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import A75117132491249378_23700H0HTM from '@/components/375117132491249378_23700-h-0.htm'
 import A75117132491249378_23700H1HTM from '@/components/375117132491249378_23700-h-1.htm'
 import A75117132491249378_23700H2HTM from '@/components/375117132491249378_23700-h-2.htm'
 import A75117132491249378_23700H3HTM from '@/components/375117132491249378_23700-h-3.htm'
 import A75117132491249378_23700H4HTM from '@/components/375117132491249378_23700-h-4.htm'
 import A75117132491249378_23700H5HTM from '@/components/375117132491249378_23700-h-5.htm'
 import A75117132491249378_23700H6HTM from '@/components/375117132491249378_23700-h-6.htm'
 import A75117132491249378_23700H7HTM from '@/components/375117132491249378_23700-h-7.htm'
 import A75117132491249378_23700H8HTM from '@/components/375117132491249378_23700-h-8.htm'
 import A75117132491249378_23700H9HTM from '@/components/375117132491249378_23700-h-9.htm'
 import A75117132491249378_23700H10HTM from '@/components/375117132491249378_23700-h-10.htm'
 import A75117132491249378_23700H11HTM from '@/components/375117132491249378_23700-h-11.htm'
 import A75117132491249378_23700H12HTM from '@/components/375117132491249378_23700-h-12.htm'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/wrap0000",
 			"name" : "wrap0000",
 			"component" : WRAP0000
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/alst",
 			"name" : "alst",
 			"component" : ALST
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/375117132491249378_23700-h-0.htm",
 			"name" : "375117132491249378_23700-h-0.htm",
 			"component" : A75117132491249378_23700H0HTM
 		},
 		{
 			"path" : "/375117132491249378_23700-h-1.htm",
 			"name" : "375117132491249378_23700-h-1.htm",
 			"component" : A75117132491249378_23700H1HTM
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js